module.exports = "data:text/x-markdown;base64,TWFsaWNpb3VzIHRva2VucyBhcmUgaGVsbC4gQWxzbywgc2VlIHRoZSBidWcgW2hlcmVdKGh0dHBzOi8vZ2l0aHViLmNvbS9JY2VDcmVhbVN3YXAvY29udHJhY3RzL2Jsb2IvN2U0MzNhYTFkMjYzMzY2NWI5NWExMjY4N2ExN2ZjODRkMmE5YzFhYy9mYXJtLWNvbnRyYWN0cy9NYXN0ZXJDaGVmLnNvbCkuDQo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/mainchef_complete.md
// module id = 1836
// module chunks = 0